var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgCheck = function SvgCheck(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.99917 12.6694C5.82184 12.6694 5.65251 12.5994 5.52784 12.4741L1.52851 8.4721C1.26784 8.21144 1.26784 7.78944 1.52851 7.52944C1.78917 7.26877 2.21051 7.26877 2.47117 7.52944L5.99917 11.0601L13.5272 3.53144C13.7878 3.27077 14.2092 3.27077 14.4698 3.53144C14.7305 3.7921 14.7305 4.21344 14.4698 4.4741L6.47051 12.4741C6.34584 12.5994 6.17651 12.6694 5.99917 12.6694Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99917 12.6694V12.6694C5.82184 12.6694 5.65251 12.5994 5.52784 12.4741L1.52851 8.4721C1.26784 8.21144 1.26784 7.78944 1.52851 7.52944C1.78917 7.26877 2.21051 7.26877 2.47117 7.52944L5.99917 11.0601L13.5272 3.53144C13.7878 3.27077 14.2092 3.27077 14.4698 3.53144C14.7305 3.7921 14.7305 4.21344 14.4698 4.4741L6.47051 12.4741C6.34584 12.5994 6.17651 12.6694 5.99917 12.6694",
    stroke: "currentColor"
  })));
};
export default SvgCheck;